var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * MUI 5 Popover repositions upward when the paper is taller than the space below the anchor.
 * `marginThreshold: null` keeps the menu below the button/input.
 */
export var salesOrderDetailsToolbarPopoverLayoutProps = {
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
    transformOrigin: { vertical: "top", horizontal: "left" },
    marginThreshold: null,
    disableScrollLock: true,
};
/** Layout + paper props for toolbar Popovers (Export CSV, Custom Columns). */
export function buildSalesOrderDetailsToolbarPopoverProps(paper) {
    return __assign(__assign({}, salesOrderDetailsToolbarPopoverLayoutProps), { PaperProps: paper });
}
